import { Instagram } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { useLocation, useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify"; // Import react-toastify
import "react-toastify/dist/ReactToastify.css"; // Import the styles for toast
import Navbar from "./Navbar";
import { IoArrowBack } from 'react-icons/io5';
import { useRef } from "react"; // Add useRef

import '../../App.css';
const Addinfluenecerplan = () => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [debouncedQuery, setDebouncedQuery] = useState(searchQuery);
  const [influencers, setInfluencers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [gender, setGender] = useState("");
  const [minAge, setMinAge] = useState("");
  const [maxAge, setMaxAge] = useState("");
  const [minUsersCount, setMinUsersCount] = useState("");
  const [maxUsersCount, setMaxUsersCount] = useState("");
  const [location, setLocation] = useState("");
  const [city, setCity] = useState("");
  const [country, setCountry] = useState("");
  const [isSmallScreen, setIsSmallScreen] = useState(false);
  const navigate = useNavigate();
  const locations = useLocation();
const drawerRef = useRef();
  const { planName, brandName,  ListName } = locations.state || {};


  const userId = localStorage.getItem("brandID");
  console.log('Received Plan Name:', planName);
  console.log('Received list Name:',  ListName );
  console.log('Received Brand Name:', brandName);



useEffect(() => {
  const handleClickOutside = (event) => {
    if (
      drawerRef.current &&
      !drawerRef.current.contains(event.target)
    ) {
      setIsDrawerOpen(false);
    }
  };

  if (isDrawerOpen) {
    document.addEventListener("mousedown", handleClickOutside);
  } else {
    document.removeEventListener("mousedown", handleClickOutside);
  }

  return () => {
    document.removeEventListener("mousedown", handleClickOutside);
  };
}, [isDrawerOpen]);


  
  const handleAddToList = async (influencer) => {
    // Create the data object to send to the API
    const data = {
      brandName: brandName, // You should pass this from the state or props
      planName: planName, 
      listName:  ListName, // You should pass this from the state or props
      cid: influencer.cid,
      socialType: influencer.socialType || 'INST',  // Default to 'INST' if missing
      groupID: influencer.cid,
      name: influencer.name,
      image: influencer.image,
      url: influencer.url,
      screenName: influencer.screenName,
      usersCount: influencer.usersCount,
      tags: influencer.tags,
      avgER: influencer.avgER,
      avgLikes: influencer.avgLikes,
      avgComments: influencer.avgComments,
      avgInteractions: influencer.avgInteractions,
      avgViews: influencer.avgViews,
      contactEmail: influencer.contactEmail,
      userID: userId,  // User ID from local storage
    };
  
    try {
      // Send the POST request to your API
      const response = await axios.post('https://server-side-influencer.onrender.com/brand/createplan', data);
  
      if (response.data.message) {
        // Show success message
        toast.success(response.data.message);
      }
  
      // Optionally handle success logic here (like refreshing the list, etc.)
      console.log('Plan created successfully:', response.data.data);
  
    } catch (error) {
      // Handle error and show the actual error message from the API response
      if (error.response && error.response.data && error.response.data.message) {
        toast.error(`Error: ${error.response.data.message}`);
      } else {
        // Fallback error message
        toast.error('An unexpected error occurred');
      }
  
      console.error('Error adding to the list:', error);
    }
  };
  

  const fetchInfluencers = async () => {
    setLoading(true);
    setError(null);

    try {
           const brandId = localStorage.getItem("brandID");
      const response = await axios.post(
       
         `https://server-side-influencer.onrender.com/brand/search/${brandId}`,
        {
          searchTerm: debouncedQuery,
          page: 1,
          perPage: 10,
          sort: "-score",
          socialTypes: "INST,FB",
          gender,
          minAge,
          maxAge,
          minUsersCount,
          maxUsersCount,
          location,
          city,
          country,
        }
      );
      setInfluencers(response.data.data || []);
      toast.success("Response: " + response.data.message);
    } catch (error) {
      setError("Failed to fetch data");
    } finally {
      setLoading(false);
    }
  };

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const handleViewMore = (influencer) => {
    navigate("/searchdetails", {
      state: { influencerData: influencer },
    });
  };



   useEffect(() => {
        const handleResize = () => {
   
          setIsSmallScreen(window.innerWidth <= 780);
        };
        handleResize();
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
      }, []);


  const formatNumber = (num) => {
    if (num >= 1e6) {
      return (num / 1e6).toFixed(1) + "M";
    } else if (num >= 1e3) {
      return (num / 1e3).toFixed(1) + "K";
    }
    return num;
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedQuery(searchQuery);
    }, 500);

    return () => clearTimeout(timer);
  }, [searchQuery]);

  useEffect(() => {
    fetchInfluencers();
  }, [debouncedQuery]);

  // Handle filters when Apply Filters is clickedssss
  const handleApplyFilters = () => {
    fetchInfluencers(); // Fetch with the current filter values
    setIsDrawerOpen(false); // Close the filter drawer
  };

  return (
    <div className="flex  page-scroll">
      {/* <div className="text-white fixed top-0 left-0 bottom-0 z-50">
        <Navbar />
      </div> */}

      <div className="w-full relative  page-scroll" style={{ marginLeft: isSmallScreen ? '0px' : '90px' }}>
            <div className="mb-6 text-center ml-10 " style={{
  marginTop: isSmallScreen ? '90px' : '95px',

}}>
            <h2 className="text-sm md:text-sm lg:text-3xl font-bold text-gray-800 mb-5 whitespace-nowrap overflow-hidden text-ellipsis mt-12">
  Start searching influencers and add in your plan list
</h2>
          <div className="relative w-1/2 mx-auto">
            <input
              type="text"
              placeholder="Search by name, city, or country..."
              className="w-full px-4 py-2 pl-8 rounded-full border border-gray-300 shadow-md focus:outline-none focus:ring-2 focus:ring-blue-500 mt-5"
              value={searchQuery}
              onChange={handleSearchChange}
            />
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="absolute left-3 top-3 h-5 w-5 text-gray-400"
              viewBox="0 0 20 20"
              fill="currentColor"
              aria-hidden="true"
            >
              <path
                fillRule="evenodd"
                d="M9 3a6 6 0 100 12 6 6 0 000-12zM3 9a6 6 0 1112 0 6 6 0 01-12 0z"
                clipRule="evenodd"
              />
            </svg>
          </div>
        </div>


        {/* <button
          onClick={() => setIsDrawerOpen(!isDrawerOpen)}
          className=" top-10 right-5 bg-indigo-600 text-white py-2 px-4  rounded-10 shadow-md hover:bg-indigo-700 transition-all duration-300"
        >
          Filter
        </button> */}

        {/* Filter Button positioned at the top-right */}
{/* Filter Button positioned at the top-right */}


<div
  className="mb-10 bg-gray-100 text-black flex items-center justify-between p-4 fixed w-full top-0 left-0 z-40 shadow-md"
  style={{ marginLeft: isSmallScreen ? '0px' : '86px' }}
>
  <div onClick={() => navigate(-1)} className="cursor-pointer flex items-center">
    <IoArrowBack size={24} />
    <span className="ml-2">Back</span>
  </div>
  {/* <div className="text-right font-semibold text-lg">search details </div> */}
</div>

<button
  onClick={() => setIsDrawerOpen(!isDrawerOpen)}
  className="text-white ms-10 bg-gradient-to-br from-purple-600 to-blue-500 hover:bg-gradient-to-bl focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2"
>
  Filter
</button>


        {/* Drawer for Filters */}
    <div
  className={`fixed top-0 right-0 w-96 h-full bg-white shadow-lg p-6 space-y-4 transition-transform duration-300 ease-in-out transform overflow-y-auto ${
    isDrawerOpen ? "translate-x-0" : "translate-x-full"
  }`}
>
          <div className="flex justify-between items-center mt-12">
            <h3 className="text-xl font-semibold">Filter Influencers</h3>
            <button onClick={() => setIsDrawerOpen(false)}>X</button>
          </div>

          {/* Filter Inputs */}
          <input
            type="text"
            placeholder="Gender (m/f)"
            value={gender}
            onChange={(e) => setGender(e.target.value)}
            className="w-full p-4 border border-indigo-300 rounded-md shadow-md"
          />
          <input
            type="number"
            placeholder="Min Age"
            value={minAge}
            onChange={(e) => setMinAge(e.target.value)}
            className="w-full p-4 border border-indigo-300 rounded-md shadow-md"
          />
          <input
            type="number"
            placeholder="Max Age"
            value={maxAge}
            onChange={(e) => setMaxAge(e.target.value)}
            className="w-full p-4 border border-indigo-300 rounded-md shadow-md"
          />
          <input
            type="number"
            placeholder="Min Users Count"
            value={minUsersCount}
            onChange={(e) => setMinUsersCount(e.target.value)}
            className="w-full p-4 border border-indigo-300 rounded-md shadow-md"
          />
          <input
            type="number"
            placeholder="Max Users Count"
            value={maxUsersCount}
            onChange={(e) => setMaxUsersCount(e.target.value)}
            className="w-full p-4 border border-indigo-300 rounded-md shadow-md"
          />
          <input
            type="text"
            placeholder="Location"
            value={location}
            onChange={(e) => setLocation(e.target.value)}
            className="w-full p-4 border border-indigo-300 rounded-md shadow-md"
          />
          <input
            type="text"
            placeholder="City"
            value={city}
            onChange={(e) => setCity(e.target.value)}
            className="w-full p-4 border border-indigo-300 rounded-md shadow-md"
          />
          <input
            type="text"
            placeholder="Country"
            value={country}
            onChange={(e) => setCountry(e.target.value)}
            className="w-full p-4 border border-indigo-300 rounded-md shadow-md"
          />

          <button
            onClick={handleApplyFilters}
            className="w-full bg-indigo-600 text-white py-4 rounded-md"
          >
            Apply Filters
          </button>
        </div>

        {/* Display Table */}
        {loading ? (
          <div className="text-center">
            <Skeleton count={5} height={50} />
          </div>
        ) : influencers.length === 0 ? (
          <div className="text-center text-gray-500 mt-10">No search results available.</div>
        ) : (
          <div className="overflow-x-auto mt-10">
            <table className="min-w-max table-auto border-collapse  page-scroll">
              <thead>
                <tr className="bg-gray-100">
                  <th className="border p-2 whitespace-nowrap">Profile Pic</th>
                  <th className="border p-2 whitespace-nowrap">Name</th>
                  <th className="border p-2 whitespace-nowrap">User Name</th>
                  <th className="border p-2 whitespace-nowrap">Instagram URL</th>
                  <th className="border p-2 whitespace-nowrap">Gender</th>
                  <th className="border p-2 whitespace-nowrap">City</th>
                  <th className="border p-2 whitespace-nowrap">Categories</th>
                  <th className="border p-2 whitespace-nowrap">Country</th>
                  <th className="border p-2 whitespace-nowrap">Avg Views</th>
                  <th className="border p-2 whitespace-nowrap">Avg ER</th>
                  <th className="border p-2 whitespace-nowrap">Avg Interactions</th>
                  <th className="border p-2 whitespace-nowrap">Contact Email</th>
                  <th className="border p-2 whitespace-nowrap">Followers</th>
                  <th className="border p-2 whitespace-nowrap">Tags</th>
                  <th className="border p-2 whitespace-nowrap">ADD</th>
                  <th className="border p-2 whitespace-nowrap">Action</th>
                </tr>
              </thead>
              <tbody>
                {influencers.map((item) => (
                  <tr key={item.cid} className="even:bg-gray-50">
                    <td className="border p-2">
                    <img
  src={item.image ? item.image : 'https://res.cloudinary.com/dwy9jfjpq/image/upload/v1739715011/manager_profile_pics/xru8bht53ml5f5rvui9y.jpg'}
  alt={item.name}
  className="w-16 h-16 rounded-full"
/>

                    </td>
                    <td className="border p-2">{item.name || "NA"}</td>
                    <td className="border p-2">{item.screenName || "NA"}</td>
                    <td className="border p-2">
                      {item.url ? (
                        <a href={item.url} target="_blank" rel="noopener noreferrer">
                          <IconButton>
                            <Instagram style={{ color: "#9b4dca" }} />
                          </IconButton>
                        </a>
                      ) : (
                        "NA"
                      )}
                    </td>
                    <td className="border p-2">{item.gender || "NA"}</td>
                    <td className="border p-2">{item.city || "NA"}</td>
                    <td className="border p-2">
                      {item.categories.join(", ") || "NA"}
                    </td>
                    <td className="border p-2">{item.country || "NA"}</td>
                    <td className="border p-2">{formatNumber(item.avgViews) || "NA"}</td>
                    <td className="border p-2">{item.avgER || "NA"}</td>
                    <td className="border p-2">{formatNumber(item.avgInteractions) || "NA"}</td>
                    <td className="border p-2">{item.contactEmail || "NA"}</td>
                    <td className="border p-2">{formatNumber(item.usersCount) || "NA"}</td>
                    <td className="border p-2">{item.tags.slice(0, 4).join(", ") || "NA"}</td>
                    <td className="border p-2">
                      <button
                        className="text-white bg-gradient-to-br from-purple-600 to-blue-500 hover:bg-gradient-to-bl focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2"
                        onClick={() => handleAddToList(item)}
                      >
                        Add to List
                      </button>
                    </td>
                    <td className="border p-2">
                    <button
  className="text-white bg-gradient-to-br from-purple-600 to-blue-500 hover:bg-gradient-to-bl focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2"
  onClick={() => handleViewMore(item)}
>
  View More
</button>

                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
      <ToastContainer />
    </div>
  );
};

export default Addinfluenecerplan;
